import { render } from "./MaterialPagination.vue?vue&type=template&id=21b8e27f"
import script from "./MaterialPagination.vue?vue&type=script&lang=js"
export * from "./MaterialPagination.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__